"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("antd/dist/antd.css");
var _antd2 = require("antd");
var _formSwitcher = _interopRequireDefault(require("./form-switcher.js"));
var _ScrollableContainer = _interopRequireDefault(require("../scrollbars/ScrollableContainer.js"));
var _allAppsMenu = _interopRequireDefault(require("../all-apps-menu/all-apps-menu"));
var _turingFooter = _interopRequireDefault(require("../turing-footer/turing-footer"));
var _turingHeader = _interopRequireDefault(require("../turing-header/turing-header.js"));
require("./launch-screen.css");
var _allAppsItems = require("../allAppsItems.js");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
} //import ScrollBarVertical from "../scrollbars/scrollbars-vertical.js";
// importing styles
// import '../assets/style.css'
// importing Ant Design components
var Header = _antd2.Layout.Header,
  Content = _antd2.Layout.Content,
  Footer = _antd2.Layout.Footer;
var LaunchScreen = /*#__PURE__*/function (_React$Component) {
  _inherits(LaunchScreen, _React$Component);
  var _super = _createSuper(LaunchScreen);
  function LaunchScreen(props) {
    var _this;
    _classCallCheck(this, LaunchScreen);
    _this = _super.call(this, props);
    _this.state = {
      appMenu: false,
      title: _this.props.appTitle,
      view: "launchScreen mainMenuView"
    };
    return _this;
  }
  _createClass(LaunchScreen, [{
    key: "toggleAllAppsButton",
    value: function toggleAllAppsButton() {
      //    console.log("toggleAllAppsButton");
      this.setState({
        appMenu: !this.state.appMenu,
        title: this.state.title === this.props.appTitle ? "All Apps" : this.props.appTitle,
        titleClass: this.state.titleClass === "allAppsTitle" ? "appTitle" : "allAppsTitle"
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "logo"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('../../uiux/assets/images/logo.svg')
      }), /*#__PURE__*/_react["default"].createElement("h2", {
        className: this.state.titleClass
      }, this.state.title));
    }
  }, {
    key: "renderAllApsMenu",
    value: function renderAllApsMenu() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "allAppsContainer"
      }, /*#__PURE__*/_react["default"].createElement(_allAppsMenu["default"], {
        allAppsItems: _allAppsItems.allAppsItems
      }));
    }
  }, {
    key: "renderAllAppsButton",
    value: function renderAllAppsButton() {
      var _this2 = this;
      return this.props.appMenu ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "all-apps-btn",
        onClick: function onClick() {
          _this2.toggleAllAppsButton();
        }
      }) : "";
    }
  }, {
    key: "renderCover",
    value: function renderCover() {
      var images = {
        turingWorldwide: require('../../uiux/assets/images/turing-worldwide.png'),
        turingMagic: require('../../uiux/assets/images/turing-magic.svg'),
        turingFuture: require('../../uiux/assets/images/turing-future.jpg')
      };
      var welcomeImage = images[this.props.welcomeImage] ? images[this.props.welcomeImage] : this.props.welcomeImage;
      return [/*#__PURE__*/_react["default"].createElement("div", {
        className: "welcomeImage",
        key: "welcomeImage"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: welcomeImage
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "footerWraper",
        key: "footerWraper"
      }, /*#__PURE__*/_react["default"].createElement(Footer, null, /*#__PURE__*/_react["default"].createElement(_turingFooter["default"], {
        backgroundColor: "#fff"
      })))];
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_antd2.Layout, {
        className: "launchScreen"
      }, /*#__PURE__*/_react["default"].createElement(_ScrollableContainer["default"], {
        vertical: true,
        backgroundColor: "#fff",
        containerClassName: "coverContainer",
        scrollableClassName: "coverItems"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "header"
      }, this.renderHeader(), this.renderAllAppsButton()), !this.state.appMenu ? this.renderCover() : this.renderAllApsMenu()), /*#__PURE__*/_react["default"].createElement("div", {
        id: "formContainer1"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "scroll-mask"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: "formContainer2"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "formContainer3"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "formContainer4"
      }, this.props.content || this.props.children)))), /*#__PURE__*/_react["default"].createElement(SystemMessage, {
        content: this.props.systemMessage
      }), /*#__PURE__*/_react["default"].createElement(LoginMessage, {
        content: this.props.loginMessage
      }), /*#__PURE__*/_react["default"].createElement(LoginStatus, {
        content: this.props.loginStatus
      }), /*#__PURE__*/_react["default"].createElement(SystemStatus, {
        content: this.props.systemStatus
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "footerWraperMobile"
      }, /*#__PURE__*/_react["default"].createElement(Footer, null, /*#__PURE__*/_react["default"].createElement(_turingFooter["default"], {
        backgroundColor: "#f0f0f0"
      }))));
    }
  }]);
  return LaunchScreen;
}(_react["default"].Component);
var SystemMessage = function SystemMessage(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "systemMessage"
  }, props.content);
};
var LoginMessage = function LoginMessage(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "loginMessage"
  }, props.content);
};
var LoginStatus = function LoginStatus(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "loginStatus"
  }, props.content);
};
var SystemStatus = function SystemStatus(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "systemStatus"
  }, props.content);
};
var _default = exports["default"] = LaunchScreen;